/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MiscSupplyDefinitions {
    angular.module("meevo.plugins.miscSupplyDefinitions", []);
}